import {
    DATA_BANK_VIEW_CASTE_SUMMARY,
    DATA_BANK_VIEW_CONSTITUENCY_MAP,
    DATA_BANK_VIEW_PAST_ELECTION,
    type DataBankViewType,
} from "./dataBankViewTypes";
import type { ConnectDataBankFormVals } from "./ConnectDataBankPickers";

export function isConnectDataBankFormComplete(data: ConnectDataBankFormVals): boolean {
    if (!data.fst || !data.fsd || !data.viewType) return false;
    if (data.viewType === DATA_BANK_VIEW_PAST_ELECTION) return Boolean(data.election);
    if (data.viewType === DATA_BANK_VIEW_CONSTITUENCY_MAP) return Boolean(data.mapKey);
    return data.viewType === DATA_BANK_VIEW_CASTE_SUMMARY;
}

export function connectDataBankMorePayload(data: ConnectDataBankFormVals): Record<string, unknown> {
    const viewType = data.viewType as DataBankViewType;
    const more: Record<string, unknown> = {
        fst_id: data.fst!.id,
        fst_key: data.fst!.key,
        fsd_id: data.fsd!.id,
        fsd_key: data.fsd!.key,
        view_type: viewType,
    };
    if (viewType === DATA_BANK_VIEW_PAST_ELECTION) more.election_label = data.election;
    if (viewType === DATA_BANK_VIEW_CONSTITUENCY_MAP) more.map_key = data.mapKey;
    return more;
}
